// Put your applicaiton javascript here
(function($) {
  
$( document ).ready(function() {
  console.log( "ready!" );
    
// Open menu
$('.main-menu-toggle').on('click', function(){
    $('body').toggleClass('menu-open');
});

$('.menu-button, .body-wrapper-full').on('click', function(e){
    e.preventDefault();
    $('body').toggleClass('menu-open');
});
  
//carousel-hero
$('.carousel-hero').owlCarousel({
    items: 1,
    loop: false,
    nav: false,
    dots: true,
    autoplay: false,
    autoplayTimeout: 5000,
    margin: 0,
    responsive: {
        0: {
            items: 1
        }
    },
});
  
//carousel-quote
$('.carousel-quote').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    dots: true,
    autoplay: false,
    autoplayTimeout: 5000,
    margin: 0,
    navText: [
        '<i class="glyphicon glyphicon-menu-left"></i>',
        '<i class="glyphicon glyphicon-menu-right"></i>'
    ],
    responsive: {
        0: {
            items: 1
        }
    },
});
  
  
//carousel-single-product
$('.carousel-single-product').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 5000,
    margin: 0,
    navText: [
        '<i class="fa fa-chevron-left"></i>',
        '<i class="fa fa-chevron-right"></i>'
    ],
    responsive: {
        0: {
            items: 1
        }
    },
});
  

document.querySelectorAll('.address-delete-form').forEach((deleteForm) => {
    deleteForm.addEventListener('submit', (event) => {
        const confirmMessage = event.target.getAttribute('data-confirm-message');

        if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            event.preventDefault();
        }
    });
});
  
if (typeof allCountryOptionTags !== 'undefined') {
const billingCountryProvinceSelector = new CountryProvinceSelector(allCountryOptionTags);

   
  if($('#AddressCountryNew').length){
billingCountryProvinceSelector.build(document.querySelector('#AddressCountryNew'), document.querySelector('#AddressProvinceNew'));
  }
  
  if($('.edit-country').length){ 
billingCountryProvinceSelector.build(document.querySelector('.edit-country'), document.querySelector('.edit-province')); 
  }
}
  
  jQuery(document).ready(function(){
    // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($(fieldName).val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $(fieldName).val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
             $(fieldName).val(0);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($(fieldName).val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $(fieldName).val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $(fieldName).val(0);
        }
    });
});
  
  
});
})( jQuery );